import TicketPage from "./TicketPage";

export default TicketPage;
